// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__R7jaD","lock":"Forbidden_lock__eJ8fB","dip":"Forbidden_dip__s3AUL","spin":"Forbidden_spin__fz+bL"};